import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import LoyaltyOptInModal from "../../components/LoyaltyOptInModal";
import { LOYALTY_NEW_IN_EXPERIMENT_KEY } from "../../state/modules/category/constants";
import {
  getLoyaltyIsOptedIn,
  getLoyaltyIsEnabled,
  getEnableComplianceVariant,
  getStoreCode
} from "../../state/modules/config/selectors";
import {
  analyticsLoyaltyOptInClick,
  analyticsLoyaltyOptInReject
} from "../../state/modules/analytics/actions";

import { getCategoryDetails } from "../../state/modules/category";
import { loyaltyOptIn } from "../../state/modules/config/actions";
import sdkProvider from "../../client/sdkProvider";

const ConnectedLoyaltyOptInModal = props => {
  const loyaltyIsOptedIn = useSelector(getLoyaltyIsOptedIn);
  const categoryDetails = useSelector(getCategoryDetails);
  const loyaltyIsEnabled = useSelector(getLoyaltyIsEnabled);
  const enableComplianceVariant = useSelector(getEnableComplianceVariant);
  const storeCode = useSelector(getStoreCode);
  const dispatch = useDispatch();

  const [
    loyaltyNewInExperimentEnabled,
    setLoyaltyNewInExperimentEnabled
  ] = useState(false);

  useEffect(() => {
    const loadExperimentFlag = async () => {
      try {
        const featuresSdk = await sdkProvider("features");
        await featuresSdk.onReady();

        const { isEnabled, getVariables } =
          featuresSdk.getFeature(LOYALTY_NEW_IN_EXPERIMENT_KEY, null, {
            app: "plp"
          }) || {};
        const enabled =
          (isEnabled() && getVariables()?.bucket === "v2") || false;

        if (enabled) {
          setLoyaltyNewInExperimentEnabled(true);
        }
      } catch (error) {
        setLoyaltyNewInExperimentEnabled(false);
      }
    };

    loadExperimentFlag();
  }, []);

  return (
    <LoyaltyOptInModal
      {...props}
      loyaltyBenefitType={categoryDetails.loyaltyBenefit?.type}
      enableComplianceVariant={enableComplianceVariant}
      loyaltyIsEnabled={loyaltyIsEnabled}
      loyaltyIsOptedIn={loyaltyIsOptedIn}
      loyaltyNewInExperimentEnabled={loyaltyNewInExperimentEnabled}
      storeCode={storeCode}
      loyaltyOptIn={() => dispatch(loyaltyOptIn())}
      analyticsLoyaltyOptInClick={() => dispatch(analyticsLoyaltyOptInClick())}
      analyticsLoyaltyOptInReject={() =>
        dispatch(analyticsLoyaltyOptInReject())
      }
    />
  );
};

export default ConnectedLoyaltyOptInModal;
